<app-header [forceLightBackground]="true"></app-header>
<div class="discussion-home">
  <!-- Review Comments cell templates (commentsPendingActionCell is inline in table, same as Pending Reviews) -->
  <ng-template #commentsHistoryStatusCell let-row>
    <span class="status-chip" [class.status-chip--approved]="row.status === 'Approved'" [class.status-chip--rejected]="row.status === 'Rejected'" [class.status-chip--action-required]="row.status === 'Action Required'">{{ row.status || 'N/A' }}</span>
  </ng-template>
  <ng-template #commentsReportedActionCell let-row>
    <div class="action-cell-wrapper">
      <button class="action-btn" (click)="toggleCommentsReportedDropdown($event, row)" [class.active]="isCommentsReportedDropdownOpen(row)" type="button">
        <span>Action</span>
      </button>
    </div>
  </ng-template>
  <ng-template #commentsReportHistoryStatusCell let-row>
    <span class="status-chip" [class.status-chip--approved]="row.status === 'Approved'" [class.status-chip--rejected]="row.status === 'Rejected'" [class.status-chip--action-required]="row.status === 'Action Required'">{{ row.status || 'N/A' }}</span>
  </ng-template>

  <div class="discussion-home--layout">
    <app-admin-sidebar class="discussion-home--sidebar"></app-admin-sidebar>
    <div class="discussion-home--content">
      <app-page-header
        title="Discussion"
        description="View and manage discussions">
      </app-page-header>
      
      <div class="discussion-container">
        <!-- Tabs -->
        <div class="discussion-tabs">
          <button
            class="discussion-tabs--tab"
            [class.active]="activeTab === 'pending'"
            (click)="setTab('pending')"
            type="button"
          >
            Pending Reviews
          </button>
          <button
            class="discussion-tabs--tab"
            [class.active]="activeTab === 'history'"
            (click)="setTab('history')"
            type="button"
          >
            Review History
          </button>
          <button
            class="discussion-tabs--tab"
            [class.active]="activeTab === 'comments'"
            (click)="setTab('comments')"
            type="button"
          >
            Review Comments
          </button>
        </div>

        <!-- Tab Content -->
        <div class="discussion-tab-content">
          <!-- Pending Reviews Tab -->
          <div class="discussion-tab-pane" *ngIf="activeTab === 'pending'">
            <app-table
              [columns]="pendingColumns"
              [data]="pendingData"
              [scrollHeight]="'500px'"
              [loading]="isLoadingPending"
              [pagination]="pendingPagination"
              [emptyMessage]="'No pending reviews found'"
              [striped]="true"
              [bordered]="true"
              [hoverable]="true"
            >
              <!-- Custom Category Column: icon + Dataset/Model (Catalogue icons) -->
              <ng-template #pendingCategoryCell let-row>
                <span class="pending-category-cell">
                  @if (getCategoryIconType(row.category) === 'dataset') {
                    <img src="/asset-dataBank.svg" alt="Dataset" class="pending-category-icon" width="16" height="16" aria-hidden="true" />
                  }
                  @if (getCategoryIconType(row.category) === 'model') {
                    <img src="/asset-ai-model.svg" alt="Model" class="pending-category-icon" width="16" height="16" aria-hidden="true" />
                  }
                  <span>{{ getCategoryDisplayLabel(row.category) }}</span>
                </span>
              </ng-template>
              <!-- Custom Action Column -->
              <ng-template #pendingActionCell let-row>
                <div class="action-cell-wrapper">
                  <button
                    class="action-btn"
                    (click)="togglePendingActionDropdown($event, row)"
                    [class.active]="isPendingDropdownOpen(row)"
                    type="button"
                  >
                    <span>Action</span>
                  </button>

                  <!-- Dropdown Menu -->
                  <div
                    class="action-dropdown-menu"
                    *ngIf="isPendingDropdownOpen(row)"
                    [attr.data-pending-dropdown-id]="row.id"
                    (click)="$event.stopPropagation()"
                  >
                    <ul class="dropdown-list">
                      <li class="dropdown-item">
                        <button class="dropdown-link" (click)="handlePendingAction('viewReview', row)">
                          View Review
                        </button>
                      </li>
                      <li class="dropdown-item">
                        <button class="dropdown-link" (click)="handlePendingAction('viewDiscussion', row)">
                          View Discussion
                        </button>
                      </li>
                    </ul>
                  </div>
                </div>
              </ng-template>
            </app-table>
          </div>

          <!-- Review History Tab -->
          <div class="discussion-tab-pane" *ngIf="activeTab === 'history'">
            <app-table
              [columns]="historyColumns"
              [data]="historyData"
              [scrollHeight]="'500px'"
              [loading]="isLoadingHistory"
              [pagination]="historyPagination"
              [emptyMessage]="'No review history found'"
              [striped]="true"
              [bordered]="true"
              [hoverable]="true"
            >
              <!-- Custom Status Column with Chip Design -->
              <ng-template #historyStatusCell let-row>
                <span class="status-chip" 
                      [class.status-chip--approved]="row.status === 'Approved'"
                      [class.status-chip--rejected]="row.status === 'Rejected'"
                      [class.status-chip--action-required]="row.status === 'Action Required'">
                  {{ row.status || 'N/A' }}
                </span>
              </ng-template>
            </app-table>
          </div>

          <!-- Review Comments Tab -->
          <div class="discussion-tab-pane" *ngIf="activeTab === 'comments'">
            <div class="review-comments-pills">
              <button
                type="button"
                class="review-comments-pill"
                [class.active]="activeCommentsPill === 'pending'"
                (click)="setCommentsPill('pending')"
              >
                Pending Reviews
              </button>
              <span class="review-comments-pill-sep" aria-hidden="true">|</span>
              <button
                type="button"
                class="review-comments-pill"
                [class.active]="activeCommentsPill === 'history'"
                (click)="setCommentsPill('history')"
              >
                Review History
              </button>
              <span class="review-comments-pill-sep" aria-hidden="true">|</span>
              <button
                type="button"
                class="review-comments-pill"
                [class.active]="activeCommentsPill === 'reported-history'"
                (click)="setCommentsPill('reported-history')"
              >
                Reported History
              </button>
            </div>

            <div class="review-comments-content">
              <!-- Pending Reviews pill: User Name, Discussion Name, Comment, Submission Date, Action (View Review) -->
              <div class="review-comments-pane" *ngIf="activeCommentsPill === 'pending'">
                <app-table
                  [columns]="commentsPendingColumns"
                  [data]="commentsPendingData"
                  [scrollHeight]="'400px'"
                  [loading]="isLoadingCommentsPending"
                  [pagination]="commentsPendingPagination"
                  [emptyMessage]="'No pending review comments'"
                  [dropdownOpenRowIndex]="commentsPendingDropdownRowIndex"
                  [striped]="true"
                  [bordered]="true"
                  [hoverable]="true"
                >
                  <!-- Action column - button only; dropdown rendered in fixed overlay -->
                  <ng-template #commentsPendingActionCell let-row>
                    <div class="action-cell-wrapper">
                      <button class="action-btn" (click)="toggleCommentsPendingDropdown($event, row)" [class.active]="isCommentsPendingDropdownOpen(row)" type="button">
                        <span>Action</span>
                      </button>
                    </div>
                  </ng-template>
                </app-table>
              </div>

              <!-- Review History pill: User Name, Discussion Name, Comment, Submission Date, Review Date, Status -->
              <div class="review-comments-pane" *ngIf="activeCommentsPill === 'history'">
                <app-table
                  [columns]="commentsHistoryColumns"
                  [data]="commentsHistoryData"
                  [scrollHeight]="'400px'"
                  [loading]="isLoadingCommentsHistory"
                  [pagination]="commentsHistoryPagination"
                  [emptyMessage]="'No review history comments'"
                  [striped]="true"
                  [bordered]="true"
                  [hoverable]="true"
                ></app-table>
              </div>

              <!-- Reported Comments pill: Reported User Name, Discussion Name, Reason, Comment, Reported Date, Action -->
              <div class="review-comments-pane" *ngIf="activeCommentsPill === 'reported-comments'">
                <app-table
                  [columns]="commentsReportedColumns"
                  [data]="commentsReportedData"
                  [scrollHeight]="'400px'"
                  [loading]="isLoadingCommentsReported"
                  [pagination]="commentsReportedPagination"
                  [emptyMessage]="'No reported comments'"
                  [dropdownOpenRowIndex]="commentsReportedDropdownRowIndex"
                  [striped]="true"
                  [bordered]="true"
                  [hoverable]="true"
                ></app-table>
              </div>

              <!-- Report History pill: Reported User Name, Discussion Name, Reason, Comment, Reported Date, Review Date, Status -->
              <div class="review-comments-pane" *ngIf="activeCommentsPill === 'reported-history'">
                <app-table
                  [columns]="commentsReportHistoryColumns"
                  [data]="commentsReportHistoryData"
                  [scrollHeight]="'400px'"
                  [loading]="isLoadingCommentsReportHistory"
                  [pagination]="commentsReportHistoryPagination"
                  [emptyMessage]="'No report history'"
                  [striped]="true"
                  [bordered]="true"
                  [hoverable]="true"
                ></app-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Fixed overlay: Comments Pending action dropdown -->
  <div
    *ngIf="commentsPendingDropdownPosition && openCommentsPendingRow"
    class="action-dropdown-overlay"
    [style.top.px]="commentsPendingDropdownPosition.top"
    [style.left.px]="commentsPendingDropdownPosition.left"
    [style.min-width.px]="commentsPendingDropdownPosition.width"
    (click)="$event.stopPropagation()"
  >
    <ul class="dropdown-list">
      <li class="dropdown-item">
        <button type="button" class="dropdown-link" (click)="handleCommentsPendingAction('viewReview', openCommentsPendingRow!)">View Review</button>
      </li>
    </ul>
  </div>

  <!-- Fixed overlay: Comments Reported action dropdown -->
  <div
    *ngIf="commentsReportedDropdownPosition && openCommentsReportedRow"
    class="action-dropdown-overlay"
    [style.top.px]="commentsReportedDropdownPosition.top"
    [style.left.px]="commentsReportedDropdownPosition.left"
    [style.min-width.px]="commentsReportedDropdownPosition.width"
    (click)="$event.stopPropagation()"
  >
    <ul class="dropdown-list">
      <li class="dropdown-item">
        <button type="button" class="dropdown-link" (click)="handleCommentsReportedAction('viewReview', openCommentsReportedRow!)">View Review</button>
      </li>
    </ul>
  </div>
</div>

<!-- View Review Modal -->
<app-modal
  [(visible)]="showReviewModal"
  header="Review Discussion"
  [width]="'720px'"
  [showFooter]="false"
  (onCancel)="closeReviewModal()"
>
  <div class="review-modal-content" *ngIf="selectedReview">
    <!-- Leaf Image (decorative) -->
    <div class="review-modal--leaf-image" aria-hidden="true">
      <img src="/assets-leaf.png" alt="" class="review-modal--leaf-img" />
    </div>

    <div class="review-modal--body">
      <!-- Scrollable content -->
      <div class="review-modal--scroll">
        <!-- Discussion details: heading outside, list inside container -->
        <section class="review-modal--details-section" aria-label="Discussion details">
          <h3 class="review-modal--details-title">Discussion details</h3>
          <div class="review-modal--details-card">
            <dl class="review-modal--details-list">
            <div class="review-modal--detail-row-inline">
              <div class="review-modal--detail-cell">
                <dt class="review-modal--detail-label">Forum</dt>
                <dd class="review-modal--detail-value">{{ selectedReview.forumName }}</dd>
              </div>
              <div class="review-modal--detail-cell">
                <dt class="review-modal--detail-label">Category</dt>
                <dd class="review-modal--detail-value">
                  <span class="review-modal--category">
                    @if (getCategoryIconType(selectedReview.category) === 'dataset') {
                      <img src="/asset-dataBank.svg" alt="" class="review-modal--category-icon" width="18" height="18" />
                    }
                    @if (getCategoryIconType(selectedReview.category) === 'model') {
                      <img src="/asset-ai-model.svg" alt="" class="review-modal--category-icon" width="18" height="18" />
                    }
                    <span>{{ getCategoryDisplayLabel(selectedReview.category) }}</span>
                  </span>
                </dd>
              </div>
            </div>
            <div class="review-modal--detail-row-inline">
              <div class="review-modal--detail-cell">
                <dt class="review-modal--detail-label">Submitted by</dt>
                <dd class="review-modal--detail-value">{{ selectedReview.userName }}</dd>
              </div>
              <div class="review-modal--detail-cell">
                <dt class="review-modal--detail-label">Submission date</dt>
                <dd class="review-modal--detail-value">{{ selectedReview.submissionDate }}</dd>
              </div>
            </div>
          </dl>
          </div>
        </section>

        <!-- Discussion content (from getReview data.content) -->
        <section class="review-modal--content-section" *ngIf="selectedReviewContent">
          <h3 class="review-modal--content-title">Discussion content</h3>
          <div class="review-modal--content-body" [innerHTML]="selectedReviewContent"></div>
        </section>

        <!-- Reject and Feedback: one row, single textarea -->
        <section class="review-modal--decision-section" aria-label="Review decision">
          <h3 class="review-modal--decision-title">Your decision</h3>

          <div class="review-modal--option-cards review-modal--option-cards-row">
            <!-- Reject option card -->
            <div class="review-modal--option-card review-modal--option-card-inline" [class.review-modal--option-card-expanded]="showRejectInput">
              <label class="review-modal--option-header">
                <input type="checkbox" class="review-modal--option-checkbox" [(ngModel)]="showRejectInput" (ngModelChange)="onRejectDecisionChange($event)" />
                <span class="review-modal--option-icon review-modal--option-icon-reject" aria-hidden="true">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <line x1="18" y1="6" x2="6" y2="18"></line>
                    <line x1="6" y1="6" x2="18" y2="18"></line>
                  </svg>
                </span>
                <span class="review-modal--option-label">Reject</span>
              </label>
            </div>

            <!-- Feedback option card -->
            <div class="review-modal--option-card review-modal--option-card-inline" [class.review-modal--option-card-expanded]="showFeedbackInput">
              <label class="review-modal--option-header">
                <input type="checkbox" class="review-modal--option-checkbox" [(ngModel)]="showFeedbackInput" (ngModelChange)="onFeedbackDecisionChange($event)" />
                <span class="review-modal--option-icon review-modal--option-icon-feedback" aria-hidden="true">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
                  </svg>
                </span>
                <span class="review-modal--option-label">Feedback</span>
              </label>
            </div>
          </div>

          @if (showRejectInput || showFeedbackInput) {
            <div class="review-modal--option-body review-modal--option-body-single">
              <textarea
                id="decision-comment-input"
                class="review-modal--option-textarea"
                [(ngModel)]="decisionComment"
                [placeholder]="showRejectInput ? 'Add reason for rejection...' : 'Add your feedback or notes for this discussion...'"
                rows="3"
              ></textarea>
            </div>
          }
        </section>
      </div>

      <!-- Action buttons: by default only Approve; Reject when Reject checked; Request Changes when Feedback checked -->
      <div class="review-modal--actions">
        @if (!showRejectInput && !showFeedbackInput) {
          <button
            type="button"
            class="review-modal--btn review-modal--btn-approve"
            (click)="handleReviewAction('approve')"
          >
            Approve
          </button>
        }
        @if (showRejectInput) {
          <button
            type="button"
            class="review-modal--btn review-modal--btn-reject"
            (click)="handleReviewAction('reject')"
          >
            Reject
          </button>
        }
        @if (showFeedbackInput) {
          <button
            type="button"
            class="review-modal--btn review-modal--btn-request"
            (click)="handleReviewAction('requestChanges')"
          >
            Request Changes
          </button>
        }
      </div>
    </div>
  </div>
</app-modal>

<!-- Comment Review Modal (View Review from Pending Reviews) -->
<app-modal
  [(visible)]="showCommentReviewModal"
  header="Review Comment"
  [width]="'580px'"
  [showFooter]="false"
  (onCancel)="closeCommentReviewModal()"
>
  <div class="comment-review-modal" *ngIf="selectedCommentReview">
    <div class="comment-review-modal__decor" aria-hidden="true">
      <img src="/assets-leaf.png" alt="" class="comment-review-modal__decor-img" />
    </div>
    <div class="comment-review-modal__body">
      <section class="comment-review-modal__section" aria-label="Discussion">
        <div class="comment-review-modal__card comment-review-modal__card--discussion">
          <span class="comment-review-modal__card-icon" aria-hidden="true">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
              <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
            </svg>
          </span>
          <div class="comment-review-modal__card-content">
            <span class="comment-review-modal__card-label">Discussion</span>
            <span class="comment-review-modal__card-value">{{ selectedCommentReview.discussionName }}</span>
            @if (selectedCommentReview.submissionDate) {
              <span class="comment-review-modal__meta">{{ selectedCommentReview.submissionDate }} · {{ selectedCommentReview.userName }}</span>
            }
          </div>
        </div>
      </section>
      <section class="comment-review-modal__section" aria-label="Comment">
        <span class="comment-review-modal__label">Comment</span>
        <div class="comment-review-modal__comment">{{ selectedCommentReview.comment }}</div>
      </section>
      <!-- Your decision section: Reject option only -->
      <section class="comment-review-modal__section review-modal--decision-section" aria-label="Review decision">
        <h3 class="review-modal--decision-title">Your decision</h3>
        <div class="review-modal--option-cards">
          <div class="review-modal--option-card" [class.review-modal--option-card-expanded]="showCommentRejectInput">
            <label class="review-modal--option-header">
              <input type="checkbox" class="review-modal--option-checkbox" [(ngModel)]="showCommentRejectInput" (ngModelChange)="onCommentRejectDecisionChange($event)" />
              <span class="review-modal--option-icon review-modal--option-icon-reject" aria-hidden="true">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
              </span>
              <span class="review-modal--option-label">Reject</span>
            </label>
          </div>
        </div>
        @if (showCommentRejectInput) {
          <div class="review-modal--option-body review-modal--option-body-single">
            <textarea
              id="comment-decision-input"
              class="review-modal--option-textarea"
              [(ngModel)]="rejectionReason"
              placeholder="Add reason for rejection..."
              rows="3"
            ></textarea>
          </div>
        }
      </section>
      <div class="comment-review-modal__actions">
        @if (!showCommentRejectInput) {
          <button type="button" class="comment-review-modal__btn comment-review-modal__btn--approve" (click)="approveCommentReview()">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="20 6 9 17 4 12"></polyline></svg>
            Approve
          </button>
        }
        @if (showCommentRejectInput) {
          <button type="button" class="comment-review-modal__btn comment-review-modal__btn--reject" (click)="rejectCommentReview()">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
            Reject
          </button>
        }
      </div>
    </div>
  </div>
</app-modal>
